<ng-container *ngIf="isAuthenticated$ | async">
  <ng-container
    *ngIf="{ navigationItem: component.data$ | async, shouldDisplayUserFirstname: shouldDisplayUserFirstname$ | async } as data"
  >
    <py-header-navigation-item
      *ngIf="data.navigationItem?.name"
      [url]="{ cxRoute: 'dashboard' } | cxUrl"
      [active]="(isMyPageActive$ | async) && !(hasActiveMenuItem$ | async)"
    >
      <i nz-icon nzType="user" nzTheme="outline"></i>
      <span *ngIf="data.shouldDisplayUserFirstname" class="ml-1 username-navigation-link-text text-nowrap">{{
        userFirstName$ | async
      }}</span>
      <span *ngIf="!data.shouldDisplayUserFirstname" class="ml-1 text-nowrap">{{ 'navigation.myPage_title' | cxTranslate }}</span>
      <ng-container *ngIf="notificationCount$ | async as notificationCount">
        <py-badge *ngIf="notificationCount > 0" id="header-menu-account-badge" [isNotification]="true" [position]="'top-right'">
          {{ notificationCount }}
        </py-badge>
      </ng-container>
    </py-header-navigation-item>
  </ng-container>
</ng-container>
